import {apiToTransaction, apiToPortfolio} from '@/services/converters'

function apiToUser(data) {
  let client = data
  client.name = data.firstName + ' ' + data.lastName
  client.portfolios = data.portfolios ? data.portfolios.map(portfolio => portfolio.id) : []
  return client
}

export {
  apiToTransaction,
  apiToPortfolio,
  apiToUser,
}



// WEBPACK FOOTER //
// ./src/-client-app/services/converters.js